'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _opentriviaapi = require('opentriviaapi');

var _opentriviaapi2 = _interopRequireDefault(_opentriviaapi);

var _QuestionWrapper = require('./components/QuestionWrapper');

var _QuestionWrapper2 = _interopRequireDefault(_QuestionWrapper);

var _CSSTransitionGroup = require('react-transition-group/CSSTransitionGroup');

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

var _styles = require('../styles/styles');

var _styles2 = _interopRequireDefault(_styles);

var _opentdb = require('../images/opentdb.png');

var _opentdb2 = _interopRequireDefault(_opentdb);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by sbardian on 5/16/17.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var OpenTrivia = function (_React$Component) {
  _inherits(OpenTrivia, _React$Component);

  function OpenTrivia(props) {
    _classCallCheck(this, OpenTrivia);

    var _this = _possibleConstructorReturn(this, (OpenTrivia.__proto__ || Object.getPrototypeOf(OpenTrivia)).call(this, props));

    _this.state = {
      loading: true,
      results: [{}],
      token: null,
      index: 0
    };
    _this.nextQuestion = _this.nextQuestion.bind(_this);
    _this.prevQuestion = _this.prevQuestion.bind(_this);
    _this.getToken = _this.getToken.bind(_this);
    return _this;
  }

  // Moves forward to the next question


  _createClass(OpenTrivia, [{
    key: 'nextQuestion',
    value: function nextQuestion() {
      var i = this.state.index;
      if (i < this.props.amount - 1) {
        i++;
      }
      this.setState({
        index: i
      });
    }

    // Moves backwards to the previous question

  }, {
    key: 'prevQuestion',
    value: function prevQuestion() {
      var i = this.state.index;
      if (i > 0) {
        i--;
      }
      this.setState({
        index: i
      });
    }
  }, {
    key: 'getToken',
    value: function getToken() {
      if (this.props.getToken && !this.state.token) {
        return _opentriviaapi2.default.getToken().then(function (data) {
          return data.token;
        });
      }
      return this.state.token;
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      this.getToken().then(function (token) {
        _this2.setState({ token: token });
        return _opentriviaapi2.default.getQuestions(_extends({ token: token }, _this2.props));
      }).then(function (data) {
        _this2.setState({
          results: data.results,
          loading: false
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return this.state.loading === true ? _react2.default.createElement(
        'div',
        { style: _styles2.default.mainContainer },
        _react2.default.createElement(
          'h1',
          null,
          'Loading Questions. . .'
        )
      ) : _react2.default.createElement(
        'div',
        { style: _styles2.default.mainContainer },
        _react2.default.createElement('img', { src: _opentdb2.default, height: 100 }),
        _react2.default.createElement(
          'h4',
          null,
          'Question: ',
          this.state.index + 1,
          ' / ',
          this.props.amount
        ),
        _react2.default.createElement(
          'div',
          { style: _styles2.default.controlBtnContainer },
          _react2.default.createElement(
            'button',
            { style: _styles2.default.controlBtn, onClick: this.prevQuestion },
            'Prev'
          ),
          _react2.default.createElement(
            'button',
            { style: _styles2.default.controlBtn, onClick: this.nextQuestion },
            'Next'
          )
        ),
        _react2.default.createElement(
          _CSSTransitionGroup2.default,
          { style: _styles2.default.cardHolder,
            transitionName: 'cardAnimate',
            transitionAppear: true,
            transitionLeave: true,
            transitionAppearTimeout: 1000,
            transitionLeaveTimeout: 1000
          },
          _react2.default.createElement(_QuestionWrapper2.default, { key: this.state.index, answerSelectedClicked: this.props.answerSelectedClicked, answerButtonClicked: this.props.answerButtonClicked, question: this.state.results[this.state.index] })
        )
      );
    }
  }]);

  return OpenTrivia;
}(_react2.default.Component);

exports.default = OpenTrivia;


OpenTrivia.propTypes = {
  amount: _propTypes2.default.number,
  category: _propTypes2.default.number,
  difficulty: _propTypes2.default.string,
  type: _propTypes2.default.string,
  encode: _propTypes2.default.string,
  getToken: _propTypes2.default.bool,
  answerSelectedClicked: _propTypes2.default.func,
  answerButtonClicked: _propTypes2.default.func
};

OpenTrivia.defaultProps = {
  amount: 1,
  results: [{}]
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /Users/sbardian/WebstormProjects/Reactjs/opentrivia-react/lib/index.js
// module id = 169
// module chunks = 0